import React from 'react';
const benefits = [{
  icon: '🩸',
  title: 'Kein Stress mehr mit dem Blutzucker',
  desc: 'Alle Rezepte halten Ihren glykämischen Index stabil. Essen Sie endlich ohne Angst.'
}, {
  icon: '🍽️',
  title: 'Essen Sie wieder, was Sie möchten',
  desc: '500 verschiedene Gerichte. Keine Verbotsliste. Kein schlechtes Gewissen.'
}, {
  icon: '😴',
  title: 'Endlich wieder tief schlafen',
  desc: 'Stabile Blutzuckerwerte bedeuten erholsamen Schlaf — und echte Energie am nächsten Morgen.'
}, {
  icon: '🧠',
  title: 'Mehr Energie. Weniger Stress.',
  desc: 'Wenn der Körper im Gleichgewicht ist, folgt der Geist. Mehr Klarheit. Mehr Lebensqualität.'
}];
export function BenefitsSection() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-20">
      <div className="max-w-xl mx-auto" data-id="element-21">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center mb-6 sm:mb-8 text-brand-text-main" data-id="element-22">
          Was sich in Ihrem Leben verändern wird
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-23">
          {benefits.map((b, i) => <div key={i} className="bg-white p-5 rounded-xl border border-brand-sage/20 shadow-sm text-center" data-id="element-24">
              <div className="text-3xl mb-3" data-id="element-25">{b.icon}</div>
              <h3 className="font-bold text-brand-text-main text-sm sm:text-base mb-2 leading-tight" data-id="element-26">
                {b.title}
              </h3>
              <p className="text-xs sm:text-sm text-brand-text-muted leading-relaxed" data-id="element-27">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}